/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";

import { Table, TableHead, TableRow, TableBody, TableCell, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@material-ui/core";
import { convertToMoneyWordEN } from "./../../../services/libService";
import moment from "moment";
import { Button, Checkbox, CircularProgress } from "@mui/material";
import ReactHtmlParser from "react-html-parser";
import { sumOfField } from "./../../../services/libService";

const FormCIForAirport = ({ data = "", onCheckbox, onCheckAll, onChange }) => {
  const isThereAirlineInProduct = data?.ciproducts?.some?.((item) => item.airline);
  const [selectedProductIndex, setSelectedProductIndex] = useState(-1);

  const renderUpLift = (id, ciProduct, invDetails) => {
    return (
      <div style={{ textAlign: "left", marginLeft: "30px", marginTop: "50px" }}>
        <div>
          {id}.{ciProduct.airline}-{ciProduct?.location}/{ciProduct.de_type}/{ciProduct.saletype}
        </div>
        <div style={{ marginTop: "30px" }}>
          <Table style={{ pageBreakInside: "auto" }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"No."}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Date"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray", display: ciProduct.airline === "Adhoc" ? "" : "none" }} align="center" rowSpan={2}>
                  Airline
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Tax Invoice No."}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Receipt No."}
                </TableCell>

                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Code of Aircraft"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Route"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Flight No."}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Obsd. Density"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Temp"} (°C)
                </TableCell>

                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={1} colSpan={3}>
                  {"Quantity"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {`Unit price (USD/${ciProduct?.unit || ""})`}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Amount (USD)"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  VAT {"(USD)"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} align="center" rowSpan={2}>
                  {"Total Amount (USD)"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  {"Gallon"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  {"Litre"}
                </TableCell>
                <TableCell style={{ padding: 3, border: "1px solid gray" }} padding="checkbox" align="center">
                  KG
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invDetails?.map((item, index) => (
                <TableRow key={index + 1}>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.valid_date && moment(item.valid_date).format("DD/MM/YYYY")}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray", display: ciProduct.airline === "Adhoc" ? "" : "none" }}>
                    {item.adhoc_shippedto}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.code}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.fkey}
                  </TableCell>

                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.code_aircraft}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.route}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.flight_no}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.density == "" ? "-" : (+item.density)?.toLocaleString("de-DE", { minimumFractionDigits: 4, maximumFractionDigits: 4 })}
                  </TableCell>
                  <TableCell align="center" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.temp == "" ? "-" : (+item.temp)?.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>

                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Math.round(item.sub_gallon)?.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Math.round(item.sub_lit)?.toLocaleString()}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Math.round(item.sub_kg)?.toLocaleString()}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(item.price)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.sub_amount)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {item.vat === -1 ? "\\" : Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.vat)}
                  </TableCell>
                  <TableCell align="right" style={{ padding: 3, border: "1px solid gray" }}>
                    {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.total)}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
                {/* <TableCell style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }} colSpan={(data.loadingtype_id == 1 ? 8 : 3) + (ciProduct.airline == "Adhoc" ? 1 : 0)}></TableCell> */}
                <TableCell style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }} colSpan={8 + (ciProduct.airline == "Adhoc" ? 1 : 0)}>
                  {"TOTAL"}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Math.round(sumOfField(invDetails, "sub_gallon"))?.toLocaleString("de-DE")}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Math.round(sumOfField(invDetails, "sub_lit"))?.toLocaleString()}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Math.round(sumOfField(invDetails, "sub_kg"))?.toLocaleString()}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sumOfField(invDetails, "sub_amount"))}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                    sumOfField(
                      invDetails?.filter((item) => item.vat > 0),
                      "vat"
                    )
                  )}
                </TableCell>
                <TableCell align="right" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                  {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(sumOfField(invDetails, "total"))}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </div>
    );
  };

  const renderTable = () => {
    if (data.ciproducts?.length)
      return (
        <Table aria-label="spanning table" size="small" border={1}>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Number
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold", display: isThereAirlineInProduct ? "" : "none" }} align="center" rowSpan={2}>
                Airline
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Location
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Type of Delivery
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Route
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" colSpan={2}>
                Quantity
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                UnitPrice (USD)
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                Amount (USD)
              </TableCell>
              {Boolean(onCheckbox) && (
                <>
                  <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" rowSpan={2}>
                    Debtor days
                  </TableCell>
                  <TableCell rowSpan={2} padding="checkbox" align="center" style={{ padding: 3, border: "1px solid gray", whiteSpace: "nowrap" }}>
                    <Button variant="contained" color="secondary" onClick={onCheckAll}>
                      Select all
                    </Button>
                  </TableCell>
                </>
              )}
            </TableRow>
            <TableRow>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center">
                MT
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center">
                USG
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.ciproducts.map((item, index) => (
              <TableRow
                key={index}
                onClick={(e) => {
                  if (!onChange) return;
                  e.stopPropagation(true);
                  setSelectedProductIndex(index);
                }}
                style={{ cursor: onChange ? "pointer" : "" }}
              >
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {index + 1}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", display: isThereAirlineInProduct ? "" : "none" }} align="center">
                  {item.airline}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.location}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.de_type}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                  {item.saletype}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {item.mt?.toLocaleString()}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {Math.round(item.gallon)?.toLocaleString()}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {item.price ? Intl.NumberFormat("ja-JP", { minimumFractionDigits: 4, maximumFractionDigits: 4 }).format(item.price) : "-"}
                </TableCell>
                <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="right">
                  {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.amount)}
                </TableCell>
                {Boolean(onCheckbox) && (
                  <>
                    <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray" }} align="center">
                      {item.period == "loading" ? <CircularProgress size={20} /> : item.period}
                    </TableCell>
                    <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}>
                      <Checkbox disabled={item.period == "loading"} checked={item.isCreateBK || false} onChange={(e, value) => onCheckbox(index, value)} />
                    </TableCell>
                  </>
                )}
              </TableRow>
            ))}
            <TableRow>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="center" colSpan={isThereAirlineInProduct ? 5 : 4}>
                Total
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {data?.ciproducts
                  .filter((i) => i.isCreateBK !== false)
                  .reduce((p, c) => p + c.mt, 0)
                  ?.toLocaleString()}
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {Math.round(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + c.gallon, 0))?.toLocaleString()}
              </TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right"></TableCell>
              <TableCell padding="checkbox" style={{ borderBottom: "1px solid gray", fontWeight: "bold" }} align="right">
                {Intl.NumberFormat("ja-JP", { minimumFractionDigits: 2 }).format(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + c.amount, 0))}
              </TableCell>
              {Boolean(onCheckbox) && <TableCell align="center" style={{ padding: 3, border: "1px solid gray", fontWeight: "bold" }}></TableCell>}
            </TableRow>
          </TableBody>
        </Table>
      );
  };
  if (data)
    return (
      <div id="civiewer">
        <div style={{ pageBreakAfter: "always", margin: "20px auto", padding: "0px 30px" }}>
          <table width="100%" className="mt-1 pb-1" style={{ fontSize: 14 }}>
            <tbody>
              <tr>
                <td colSpan={4}>
                  <div align="center" style={{ position: "relative", marginBottom: 20 }}>
                    <img alt="" src="/logoP2.png" width="75px" style={{ position: "absolute", left: 75 }} />
                    <div style={{ width: "100%", color: "#071b63", fontWeight: 700, fontSize: 22, textTransform: "uppercase" }}>Commercial Invoice</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td align="right">
                  <div style={{ width: 200 }} align="left">
                    No. {data.code}
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td align="right">
                  <div style={{ width: 200 }} align="left">
                    Date: {data.effective_time && moment(data.effective_time).format("MMM DD, YYYY")}
                  </div>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>Seller:</td>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>PETROLIMEX AVIATION., JSC</td>
              </tr>
              <tr>
                <td></td>
                <td style={{ textAlign: "left" }}>Floor 6, Mipec Tower, 229 Tay Son Str. , Dong Da Dist. , Hanoi, Vietnam</td>
              </tr>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>Buyer:</td>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>{data.customer?.name}</td>
              </tr>
              <tr hidden={!data.customer.address}>
                <td style={{ textAlign: "left", fontWeight: "bold" }}></td>
                <td style={{ textAlign: "left" }}>{data.customer.address}</td>
              </tr>
              <tr>
                <td colSpan={2} style={{ textAlign: "left" }}>
                  {ReactHtmlParser(data.note)}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>Product:</td>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>Jet A-1</td>
              </tr>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>Delivery term:</td>
                <td style={{ textAlign: "left" }}>Into-plane</td>
              </tr>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }}>Due Date:</td>
                <td style={{ textAlign: "left" }}>{moment(data.end_effective_time).format("MMM DD, YYYY")}</td>
              </tr>
              {/* Render Table here */}
              <tr>
                <td colSpan={2}>{renderTable()}</td>
              </tr>
              <tr>
                <td style={{ textAlign: "left" }} colSpan={2}>
                  <p>In words: {convertToMoneyWordEN(data?.ciproducts.filter((i) => i.isCreateBK !== false).reduce((p, c) => p + c.amount, 0))}</p>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "left" }} colSpan={2}>
                  (10% VAT is included in total amount for domestic flight){" "}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "left" }} colSpan={2}>
                  <div style={{ fontWeight: "bold", textDecoration: "underline" }}>Payment intruction:</div>
                  <div>Please remit the above amount upon the receipt of the scanned Invoice to:</div>
                </td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Company:
                </td>
                <td align="left">PETROLIMEX AVIATION., JSC</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Address:
                </td>
                <td align="left">6th Floor, Mipec Tower, 299 Tay Son Str., Dong Da Dist., Hanoi, Vietnam</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Remittance bank:
                </td>
                <td align="left">{data.bact?.bank_code}</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Address:
                </td>
                <td align="left">{data.bank?.en_address}</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Account name:
                </td>
                <td align="left">PETROLIMEX AVIATION., JSC</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Account number:
                </td>
                <td align="left">{data.bact?.act_number}</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Swiftcode:
                </td>
                <td align="left">{data.bact?.swift_code}</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Intermediary Bank:
                </td>
                <td align="left">{data.bank?.ibank}</td>
              </tr>
              <tr>
                <td align="left" style={{ paddingLeft: 50 }}>
                  Swiftcode:
                </td>
                <td align="left">{data.bank?.ibswiftcode}</td>
              </tr>
              <tr>
                <td style={{ textAlign: "left", fontWeight: "bold" }} colSpan={2}>
                  <b>When making settlement, please quote Invoice No.</b>
                </td>
              </tr>
              <tr>
                <td></td>
                <td align="center">
                  <b>PETROLIMEX AVIATION</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr class="dotted" />
        <div style={{ padding: "0px 30px", marginBottom: "50px", marginTop: "50px" }}>
          <table width="100%" className="mt-1 pb-1" style={{ fontSize: 14 }}>
            <tbody>
              <tr>
                <td colSpan={4}>
                  <div align="center" style={{ position: "relative", marginBottom: 20 }}>
                    <img alt="" src="/logoP2.png" width="75px" style={{ position: "absolute", left: 75 }} />
                    <div style={{ width: "100%", color: "#071b63", fontWeight: 700, fontSize: 22, textTransform: "uppercase" }}>STATEMENT FOR FUEL UPLIFT</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          {data?.ciproducts.map((item, index) =>
            item.isCreateBK !== false ? (
              renderUpLift(
                index + 1,
                item,
                data?.invoices?.filter((invoice) => item.invoices.includes(invoice.id))
              )
            ) : (
              <></>
            )
          )}
        </div>
        <FormUpdateCIProductDialog
          open={selectedProductIndex >= 0}
          onClose={() => setSelectedProductIndex(-1)}
          initialData={data?.ciproducts[selectedProductIndex]}
          onSave={(newValue) => onChange?.(selectedProductIndex, newValue)}
        />
      </div>
    );
  else return "";
};

const FormUpdateCIProductDialog = ({ onClose, onSave, initialData, open }) => {
  const [input, setInput] = useState();
  const handleChange = (e) => {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleSave = () => {
    onSave?.(input);
    onClose?.();
  };
  useEffect(() => {
    if (!initialData) return;
    setInput(initialData);
  }, [initialData]);
  return (
    <Dialog open={Boolean(open)} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle align="center">Thông tin điều chỉnh</DialogTitle>
      <DialogContent style={{ paddingTop: 20 }}>
        <TextField style={{ marginBottom: 15 }} fullWidth name="location" label="Nơi xuất" value={input?.location || ""} onChange={handleChange} />
        <TextField style={{ marginBottom: 15 }} fullWidth name="saletype" label="Loại hình bán" value={input?.saletype || ""} onChange={handleChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Hủy</Button>
        <Button variant="contained" onClick={handleSave}>
          Lưu
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default FormCIForAirport;
